// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-l_hh","advertDetailContactGroup__header":"c-l_hi","advertDetailContactGroup__value":"c-l_hj"};